import React from "react";

/**
 * Compliance footer - Dorian Reeves / MMG Mortgages only. One page, so no
 * cross-links to other services; just the legal trail CASL/PIPEDA require.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="z-container">
        <div className="grid gap-8 md:gap-12 md:grid-cols-3">
          <div className="md:col-span-2">
            <div className="serif" style={{ fontSize: 20, fontWeight: 600, color: "var(--text-primary)" }}>
              Dorian Reeves
            </div>
            <div className="z-eyebrow" style={{ marginTop: 4, marginBottom: 16 }}>
              Mortgage Associate · MMG Mortgages
            </div>
            <p style={{ color: "var(--text-secondary)", fontSize: 14, maxWidth: 420, lineHeight: 1.6 }}>
              Serving Alberta. I read every profile personally, usually within one business day.
            </p>
          </div>

          <div>
            <div className="z-eyebrow" style={{ marginBottom: 14 }}>Legal</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/privacy" data-testid="footer-link-privacy">Privacy Policy</a>
              </li>
              <li>
                <a href="/terms" data-testid="footer-link-terms">Terms of Use</a>
              </li>
              <li>
                <a href="/cookies" data-testid="footer-link-cookies">Cookie Policy</a>
              </li>
              <li>
                <a href="mailto:dorian@mmgmortgages.ca" data-testid="footer-link-contact">
                  dorian@mmgmortgages.ca
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="site-footer-legal">
          <span data-testid="footer-copyright">
            © {year} Dorian Reeves, MMG Mortgages. All rights reserved.
          </span>
          <span>
            A pre-approval is not a guarantee of final financing. Rates and approvals vary by lender.
          </span>
        </div>
      </div>
    </footer>
  );
}
